import React from 'react'

import { ZariContext } from '_zari/context'
import { Col, Row, Button } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'
import * as CuentaContableService from 'services/cuentaContable.service'

import * as Sections from './sections'

const CODIGOS_SECCIONES = {
  ASIGNACION: 'ASI',
  GENERACION: 'GEN',
  CIERREMES15: 'CIE',
  APERTURA: 'APE'
}

const CierreClase679Page = () => {
  const __zariContext = React.useContext(ZariContext)

  const [codigoActivo, setCodigoActivo] = React.useState(null)
  const [estadoSeccion, setEstadoSeccion] = React.useState({
    [CODIGOS_SECCIONES.ASIGNACION]: false,
    [CODIGOS_SECCIONES.GENERACION]: false,
    [CODIGOS_SECCIONES.CIERREMES15]: false,
    [CODIGOS_SECCIONES.APERTURA]: false
  })

  const clickCambioSeccion = React.useCallback(nuevo => {
    setCodigoActivo(nuevo)
  }, [])

  const validarCuentasClase6789ConEnlaceCierre = React.useCallback(() => {
    __zariContext.loader.open('Verificando estado de PASO 1.')

    CuentaContableService.validarCuentasClase6789ConEnlaceCierre()
      .then(() => {
        clickCambioSeccion(CODIGOS_SECCIONES.GENERACION)
        setEstadoSeccion({
          [CODIGOS_SECCIONES.ASIGNACION]: true,
          [CODIGOS_SECCIONES.GENERACION]: false,
          [CODIGOS_SECCIONES.CIERREMES15]: false,
          [CODIGOS_SECCIONES.APERTURA]: false
        })
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('warning', `${error}. Completar paso 1.`)
        clickCambioSeccion(CODIGOS_SECCIONES.ASIGNACION)
        setEstadoSeccion({
          [CODIGOS_SECCIONES.ASIGNACION]: false,
          [CODIGOS_SECCIONES.GENERACION]: false,
          [CODIGOS_SECCIONES.CIERREMES15]: false,
          [CODIGOS_SECCIONES.APERTURA]: false
        })
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, clickCambioSeccion])

  const validarSaldoCeroClases6789 = React.useCallback(() => {
    __zariContext.loader.open('Verificando estado de PASO 2.')

    AsientoContableService.validarSaldoCeroClases6789()
      .then(() => {
        clickCambioSeccion(CODIGOS_SECCIONES.CIERREMES15)
        setEstadoSeccion({
          [CODIGOS_SECCIONES.ASIGNACION]: true,
          [CODIGOS_SECCIONES.GENERACION]: true,
          [CODIGOS_SECCIONES.CIERREMES15]: false,
          [CODIGOS_SECCIONES.APERTURA]: false
        })
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('warning', `${error}. Completar paso 2.`)
        clickCambioSeccion(CODIGOS_SECCIONES.GENERACION)
        setEstadoSeccion({
          [CODIGOS_SECCIONES.ASIGNACION]: true,
          [CODIGOS_SECCIONES.GENERACION]: false,
          [CODIGOS_SECCIONES.CIERREMES15]: false,
          [CODIGOS_SECCIONES.APERTURA]: false
        })
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, clickCambioSeccion])

  const validarSaldoCeroClases12345 = React.useCallback(() => {
    __zariContext.loader.open('Verificando estado de PASO 3.')

    AsientoContableService.validarSaldoCeroClases12345()
      .then(() => {
        clickCambioSeccion(CODIGOS_SECCIONES.APERTURA)
        setEstadoSeccion({
          [CODIGOS_SECCIONES.ASIGNACION]: true,
          [CODIGOS_SECCIONES.GENERACION]: true,
          [CODIGOS_SECCIONES.CIERREMES15]: true,
          [CODIGOS_SECCIONES.APERTURA]: false
        })
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('warning', `${error}. Completar paso 3.`)
        clickCambioSeccion(CODIGOS_SECCIONES.CIERREMES15)
        setEstadoSeccion({
          [CODIGOS_SECCIONES.ASIGNACION]: true,
          [CODIGOS_SECCIONES.GENERACION]: true,
          [CODIGOS_SECCIONES.CIERREMES15]: false,
          [CODIGOS_SECCIONES.APERTURA]: false
        })
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, clickCambioSeccion])

  React.useEffect(() => {
    validarCuentasClase6789ConEnlaceCierre()
  }, [validarCuentasClase6789ConEnlaceCierre])

  return (
    <>
      <Row>
        <Col md={4}>
          <Row className='mb-2'>
            <Col md={12}>
              <Button
                block
                tiny
                outline={!estadoSeccion[CODIGOS_SECCIONES.ASIGNACION] && codigoActivo !== CODIGOS_SECCIONES.ASIGNACION}
                onClick={() => clickCambioSeccion(CODIGOS_SECCIONES.ASIGNACION)}
                color={estadoSeccion[CODIGOS_SECCIONES.ASIGNACION] ? 'success' : 'primary'}
              >
                <b>PASO 1:</b> Asignación de enlaces
                {estadoSeccion[CODIGOS_SECCIONES.ASIGNACION] ? <b> (COMPLETADO)</b> : ' (PENDIENTE)'}
              </Button>
            </Col>
          </Row>
          <Row className='mb-2'>
            <Col md={12}>
              <Button
                block
                tiny
                outline={!estadoSeccion[CODIGOS_SECCIONES.GENERACION] && codigoActivo !== CODIGOS_SECCIONES.GENERACION}
                onClick={() => clickCambioSeccion(CODIGOS_SECCIONES.GENERACION)}
                color={estadoSeccion[CODIGOS_SECCIONES.GENERACION] ? 'success' : 'primary'}
                disabled={!estadoSeccion[CODIGOS_SECCIONES.ASIGNACION]}
              >
                <b>PASO 2:</b> Generacion de asientos
                {estadoSeccion[CODIGOS_SECCIONES.GENERACION] ? <b> (COMPLETADO)</b> : ' (PENDIENTE)'}
              </Button>
            </Col>
          </Row>
          <Row className='mb-2'>
            <Col md={12}>
              <Button
                block
                tiny
                outline={
                  !estadoSeccion[CODIGOS_SECCIONES.CIERREMES15] && codigoActivo !== CODIGOS_SECCIONES.CIERREMES15
                }
                onClick={() => clickCambioSeccion(CODIGOS_SECCIONES.CIERREMES15)}
                color={estadoSeccion[CODIGOS_SECCIONES.CIERREMES15] ? 'success' : 'primary'}
                disabled={!estadoSeccion[CODIGOS_SECCIONES.ASIGNACION] || !estadoSeccion[CODIGOS_SECCIONES.GENERACION]}
              >
                <b>PASO 3:</b> Cierre cuentas activo, pasivo y patrimonio
                {estadoSeccion[CODIGOS_SECCIONES.CIERREMES15] ? <b> (COMPLETADO)</b> : ' (PENDIENTE)'}
              </Button>
            </Col>
          </Row>
          <Row className='mb-2'>
            <Col md={12}>
              <Button
                block
                tiny
                outline={!estadoSeccion[CODIGOS_SECCIONES.APERTURA] && codigoActivo !== CODIGOS_SECCIONES.APERTURA}
                onClick={() => clickCambioSeccion(CODIGOS_SECCIONES.APERTURA)}
                color={estadoSeccion[CODIGOS_SECCIONES.APERTURA] ? 'success' : 'primary'}
                disabled={!estadoSeccion[CODIGOS_SECCIONES.ASIGNACION] || !estadoSeccion[CODIGOS_SECCIONES.CIERREMES15]}
              >
                <b>PASO 4:</b> Generar asiento apertura (OPCIONAL)
              </Button>
            </Col>
          </Row>
        </Col>
        <Col md={8}>
          {codigoActivo === CODIGOS_SECCIONES.ASIGNACION && (
            <Sections.AsignacionEnlaceSection
              validarCuentasClase6789ConEnlaceCierre={validarCuentasClase6789ConEnlaceCierre}
            />
          )}
          {codigoActivo === CODIGOS_SECCIONES.GENERACION && (
            <Sections.GeneracionAsientosSection validarSaldoCeroClases6789={validarSaldoCeroClases6789} />
          )}
          {codigoActivo === CODIGOS_SECCIONES.CIERREMES15 && (
            <Sections.CierreActivoPasivoPatrimonioSection validarSaldoCeroClases12345={validarSaldoCeroClases12345} />
          )}
          {codigoActivo === CODIGOS_SECCIONES.APERTURA && <Sections.GenerarAperturaSiguienteAnoSection />}
        </Col>
      </Row>
    </>
  )
}

export default React.memo(CierreClase679Page)
